import React from "react";

const CustomInput = ({
  label,
  value,
  onChange,
  onClick,
  isNumberInput = true,
  readOnly = false,
  placeholder,
}) => {
  return (
    <div className="flex flex-col w-full">
      {/* Label */}
      <label className="text-xs font-medium text-n500 mb-1">{label}</label>

      {/* Input Container */}
      <div className="mb-4 h-10 border border-gray-400 rounded px-2 flex items-center">
        <input
          type={isNumberInput ? "number" : "text"}
          value={value}
          onChange={onChange}
          onClick={onClick}
          readOnly={readOnly}
          placeholder={!isNumberInput ? placeholder || "dd-mm-yyyy" : ""}
          className="w-full h-full text-xs text-p300 font-medium font-['Graphik'] focus:outline-none bg-transparent"
        />

        {/* Calendar Icon for date inputs */}
        {!isNumberInput && (
          <button
            type="button"
            onClick={onClick}
            className="text-n500 hover:text-p300 p-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomInput;
